/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Hero_Title_AccentInputs */

const en_why_listening_hero_title_accent = /** @type {(inputs: Why_Listening_Hero_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hear only what matters.`)
};

const es_why_listening_hero_title_accent = /** @type {(inputs: Why_Listening_Hero_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oye solo lo que importa.`)
};

/**
* | output |
* | --- |
* | "Hear only what matters." |
*
* @param {Why_Listening_Hero_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_hero_title_accent = /** @type {((inputs?: Why_Listening_Hero_Title_AccentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Hero_Title_AccentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_hero_title_accent(inputs)
	return en_why_listening_hero_title_accent(inputs)
});